import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";

import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";

@Injectable()
export class OpenBankingService {
  constructor(private http: HttpClientService) {}

  public getTransactions(application_id: string): Observable<any> {
    return this.http
      .get("/api/applications/" + application_id + "/transactions")
      .pipe(tap((_) => console.log("OpenBankingService.getTransactions: Ok.")));
  }

  public getTransactionsOB(validation_processes_id: string | number): Observable<any> {
    return this.http
      .get("/api/validation_processes/" + validation_processes_id + "/finerio_transactions")
      .pipe(tap((_) => console.log("OpenBankingService.getTransactionsOB: Ok.")));
  }

  public getTransactionsOCR(application_id: string): Observable<any> {
    return this.http
      .get("/api/applications/" + application_id + "/ocr_transactions")
      .pipe(tap((_) => console.log("OpenBankingService.getTransactionsOCR: Ok.")));
  }

  public getTextract(application_id: string): Observable<any> {
    return this.http
      .get("/api/applications/" + application_id + "/textract")
      .pipe(tap((_) => console.log("OpenBankingService.getTextract: Ok.")));
  }
  public shareTextract(person_id: string): Observable<any> {
    return this.http
      .get("/api/persons/" + person_id + "/textract/share")
      .pipe(tap((_) => console.log("OpenBankingService.shareTextract: Ok.")));
  }
  public markAsLayout(textract_id: string): Observable<any> {
    return this.http
      .delete("/api/textract/" + textract_id + "/delete_transactions")
      .pipe(tap((_) => console.log("OpenBankingService.markAsLayout: Ok.")));
  }

  public deleteTransaction(transactionId: Number): Observable<any> {
    return this.http
      .delete("/api/open_banking/transactions/" + transactionId)
      .pipe(tap((_) => console.log("OpenBankingService.deleteTransactions: Ok.")));
  }

  public postTransactions(id: string, transactions: any[]): Observable<any> {
    const params = {
      transactions,
    };
    return this.http
      .post("/api/persons/" + id + "/open_banking/transactions", params)
      .pipe(tap((_) => console.log("OpenBankingService.postTransactions: Ok.")));
  }

  public postSingleTransaction(textract_id, transaction) {
    return this.http
      .post("/api/textract/" + textract_id + "/create", transaction)
      .pipe(tap((_) => console.log("OpenBankingService.postSingleTransaction: Ok.")));
  }
  public postLayout(doc) {
    return this.http
      .post("/api/textract/" + doc.id + "/layout", doc)
      .pipe(tap((_) => console.log("OpenBankingService.postLayout: Ok.")));
  }
  public updateSingleTransaction(transaction) {
    return this.http
      .post("/api/textract/" + transaction.id + "/update", transaction)
      .pipe(tap((_) => console.log("OpenBankingService.updateSingleTransaction: Ok.")));
  }
  public updateTextractDocument(doc) {
    return this.http
      .post("/api/textract/" + doc.id + "/callback", doc)
      .pipe(tap((_) => console.log("OpenBankingService.UpdateTextractDocument: Ok.")));
  }

  public getCredentials(id: string): Observable<any> {
    return this.http
      .get("/api/validation_processes/" + id + "/open_banking/credentials")
      .pipe(tap((_) => console.log("OpenBankingService.getCredentials: Ok.")));
  }

  public getAccounts(id: string): Observable<any> {
    return this.http
      .get("/api/open_banking/credentials/" + id + "/accounts")
      .pipe(tap((_) => console.log("OpenBankingService.getAccounts: Ok.")));
  }

  public getBanks(): Observable<any> {
    return this.http
      .get("/api/open_banking/banks/all")
      .pipe(tap((_) => console.log("OpenBankingService.getBanks: Ok.")));
  }

  public getBelvoToken(): Observable<any> {
    return this.http
      .get("/api/validation_processes/open_banking/belvo/belvo_token")
      .pipe(tap((_) => console.log("OpenBankingService.getBelvoToken: Ok")));
  }

  public saveBelvoLink(link): Observable<any> {
    const params = {
      link: link,
    };
    return this.http
      .post("/api/validation_processes/open_banking/belvo/save_account", params)
      .pipe(tap((_) => console.log("OpenBankingService.saveBelvoLink: Ok")));
  }

  public getBelvoAccount(link): Observable<any> {
    const options = {
      params: {
        link: link,
      },
    };
    return this.http
      .get("/api/open_banking/banks/belvo_account", options)
      .pipe(tap((_) => console.log("OpenBankingService.getBelvoAccount: Ok")));
  }

  public saveBelvoError(vp_id, data): Observable<any> {
    const params = {
      institution: data.meta_data.institution_name,
      error: {
        validation_process_id: vp_id,
        request_id: data.request_id,
        error_code: data.meta_data.error_code,
        error_message: data.meta_data.error_message,
      },
    };
    return this.http
      .post("/api/validation_processes/open_banking/belvo/track_error", params)
      .pipe(tap((_) => console.log("OpenBankingService.saveBelvoError: Ok")));
  }

  public getBelvoTransactions(link): Observable<any> {
    const options = {
      params: {
        link: link,
      },
    };
    return this.http
      .get("/api/open_banking/banks/belvo_transactions", options)
      .pipe(tap((_) => console.log("OpenBankingService.getBelvoTransactions: Ok")));
  }

  public getPreviousBelvoData(vp_id): Observable<boolean> {
    const params = {
      validation_process_id: vp_id,
    };
    return this.http
      .post("/api/validation_processes/open_banking/belvo/check_data", params)
      .pipe(tap((_) => console.log("OpenBankingService.getPreviousBelvoData: Ok")));
  }

  public getActiveBanks(provider): Observable<any> {
    let options = { params: { provider: provider } };
    return this.http
      .get("/api/open_banking/banks", options)
      .pipe(tap((_) => console.log("OpenBankingService.getActiveBanks: Ok.")));
  }

  public getCredentialCodes(): Observable<any> {
    return this.http
      .get("/api/open_banking/credential_codes")
      .pipe(tap((_) => console.log("OpenBankingService.getErrors: Ok.")));
  }

  public getBankfields(id): Observable<any> {
    return this.http.get("/api/open_banking/bankfields/" + id, {}).pipe(
      tap((_) => console.log("OpenBankingService.getBankfields: Ok.")),
      map((response: HttpResponse<object>) => {
        return response;
      })
    );
  }

  public postCredential(validationProcessId, bank_id, username, password, security_code): Observable<any> {
    const options = {
      validation_process_id: validationProcessId,
      username: username,
      password: password,
      bank_id: bank_id,
      security_code: security_code,
    };
    return this.http
      .post("/api/validation_processes/open_banking/credentials/create_or_update", options)
      .pipe(tap((_) => console.log("OpenBankingService.postCredential: Ok.")));
  }

  public postCredentialToken(validationProcessId, username, bank_id, token): Observable<any> {
    const options = {
      token: token,
      validation_process_id: validationProcessId,
      username: username,
      bank_id: bank_id,
    };
    return this.http
      .post("/api/validation_processes/open_banking/credentials/send_token", options)
      .pipe(tap((_) => console.log("OpenBankingService.postCredentialToken: Ok.")));
  }

  public getCredential(id): Observable<any> {
    return this.http
      .get("/api/validation_processes/open_banking/credentials/" + id, {})
      .pipe(tap((_) => console.log("OpenBankingService.getCredential: Ok.")));
  }

  public getOrganizations(): Observable<any> {
    return this.http
      .get("/api/validation_processes/open_banking/organizations", {})
      .pipe(tap((_) => console.log("OpenBankingService.getOrganization: Ok.")));
  }

  public getBanksByOrganizationId(id: string): Observable<any> {
    return this.http
      .get("/api/open_banking/banks/" + id)
      .pipe(tap((_) => console.log("OpenBankingService.getBanksByOrganizationId: Ok.")));
  }

  public putCategoryValidationTransaction(transaction: any): Observable<any> {
    let options = {
      category_validation: transaction.category_validation,
    };
    return this.http
      .put(`/api/open_banking/transactions/${transaction.id}/update_validation_category`, options)
      .pipe(tap((_) => console.log("OpenBankingService.putCategoryValidationTransaction: Ok.")));
  }
}
